/* SONËA — panier tiroir, fiches produit, cartes produit. Sans dépendance. */
(() => {
  const S = window.SONEA || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Prix ---------- */
  function formatMoney(cents) {
    const fmt = S.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = (cents || 0) / 100;
    const sep = (v, d, t, c) => { const [i, f] = v.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? c + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: sep(n, 2, ',', '.'),
      amount_no_decimals: sep(n, 0, ',', '.'),
      amount_with_comma_separator: sep(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: sep(n, 0, '.', ','),
      amount_with_space_separator: sep(n, 2, ' ', ','),
      amount_with_apostrophe_separator: sep(n, 2, "'", '.'),
    }[k] ?? sep(n, 2, '.', ',')));
  }

  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(() => { t.hidden = true; }, 2600);
  }

  /* ---------- Header mobile ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-menu-toggle]');
    if (!b) return;
    const h = b.closest('.header');
    const open = h.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open);
  });

  /* ---------- Panier ---------- */
  const drawer = $('[data-cart-drawer]');
  const json = (r) => { if (!r.ok) return r.json().then((j) => Promise.reject(j)); return r.json(); };
  const getCart = () => fetch(S.routes.cartJs, { headers: { Accept: 'application/json' } }).then(json);

  function openCart() { document.body.classList.add('cart-open'); drawer && drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { document.body.classList.remove('cart-open'); drawer && drawer.setAttribute('aria-hidden', 'true'); }

  function shipping(count) {
    const need = S.freeShippingQty || 2;
    const left = Math.max(0, need - count);
    const msg = left === 0 ? 'La livraison est offerte.'
      : count === 0 ? `Livraison offerte dès ${need} paires.`
      : `Plus que ${left} paire${left > 1 ? 's' : ''} pour la livraison offerte.`;
    return { msg, pct: Math.min(100, Math.round((count / need) * 100)) };
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    if (!drawer) return;
    // Un Duo (SKU « DUO-… ») compte pour 2 paires
    const pairs = cart.items.reduce((n, it) => n + it.quantity * (/^DUO-/i.test(it.sku || '') ? 2 : 1), 0);
    const sh = shipping(pairs);
    $('[data-ship-msg]', drawer).textContent = sh.msg;
    $('[data-ship-bar]', drawer).style.width = sh.pct + '%';
    const body = $('[data-cart-body]', drawer);
    const foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = $('#cart-empty-tpl').innerHTML;
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map((it) => {
      const img = it.image ? `${it.image}${it.image.includes('?') ? '&' : '?'}width=200` : '';
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
      return `<div class="line-item" data-key="${esc(it.key)}">
        <a class="line-item__img" href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="${esc(it.product_title)}" width="80" height="80" loading="lazy">` : ''}</a>
        <div class="line-item__meta">
          <a class="line-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          <span class="line-item__variant">${variant}</span>
          <div class="line-item__qty">
            <button type="button" data-qty="${it.quantity - 1}" aria-label="Retirer un">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-qty="${it.quantity + 1}" aria-label="Ajouter un">+</button>
          </div>
        </div>
        <div class="line-item__end">
          <span class="price">${formatMoney(it.final_line_price)}</span>
          <button type="button" class="line-item__remove" data-qty="0">Retirer</button>
        </div>
      </div>`;
    }).join('');
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    foot.hidden = false;
  }

  function changeLine(key, quantity) {
    drawer && drawer.classList.add('is-loading');
    return fetch(S.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    }).then(json).then(renderCart)
      .catch((e) => toast((e && e.description) || 'Une erreur est survenue.'))
      .finally(() => drawer && drawer.classList.remove('is-loading'));
  }

  function addToCart(id, quantity) {
    return fetch(S.routes.cartAdd, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] }),
    }).then(json).then(getCart).then((cart) => { renderCart(cart); openCart(); });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]') && drawer) { e.preventDefault(); getCart().then(renderCart); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    const q = e.target.closest('[data-cart-drawer] [data-qty]');
    if (q) { changeLine(q.closest('[data-key]').dataset.key, Number(q.dataset.qty)); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // Tout formulaire d'ajout au panier (fiche produit, ajout rapide) passe par le tiroir
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form || !drawer) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    btn && (btn.disabled = true);
    const fd = new FormData(form);
    addToCart(fd.get('id'), fd.get('quantity'))
      .catch((err) => toast((err && err.description) || "Impossible d'ajouter ce produit."))
      .finally(() => { btn && (btn.disabled = false); });
  });

  /* ---------- Cartes produit : survol des pastilles ---------- */
  document.addEventListener('mouseover', (e) => {
    const sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    const card = sw.closest('[data-product-card]');
    const img = $('.product-card__media img', card);
    if (img && sw.dataset.img) { img.src = sw.dataset.img; img.removeAttribute('srcset'); }
    const input = $('form[data-add-form] input[name="id"]', card);
    if (input && sw.dataset.variantId) input.value = sw.dataset.variantId;
    $$('[data-card-swatch]', card).forEach((s) => s.setAttribute('aria-pressed', s === sw));
  });

  /* ---------- Fiche produit ---------- */
  $$('[data-product]').forEach((root) => {
    const data = JSON.parse($('[data-product-json]', root).textContent);
    const variants = data.variants;
    const idInput = $('input[name="id"]', root);
    const qtyInput = $('input[name="quantity"]', root);
    const addBtn = $('[data-add-btn]', root);
    const priceEl = $('[data-price]', root);
    const viewport = $('[data-viewport]', root);
    const slides = $$('[data-slide]', root);
    const thumbs = $$('[data-thumb]', root);
    const prevBtn = $('[data-gallery-prev]', root);
    const nextBtn = $('[data-gallery-next]', root);
    const countEl = $('[data-gallery-count]', root);
    const colorIndex = data.options.findIndex((o) => /couleur|color|colour|coloris/i.test(o));
    let current = variants.find((v) => v.id === Number(idInput.value)) || variants[0];

    const norm = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const visibleSlides = () => slides.filter((sl) => !sl.hidden);

    /* --- Carrousel --- */
    // `pos` = photo visée ; on ne la déduit du défilement qu'une fois celui-ci terminé,
    // pour que flèches et compteur restent justes pendant l'animation.
    let pos = 0;
    function indexFromScroll() {
      const vis = visibleSlides();
      if (!viewport || !vis.length) return 0;
      const x = viewport.scrollLeft;
      let best = 0;
      vis.forEach((sl, i) => { if (Math.abs(sl.offsetLeft - x) < Math.abs(vis[best].offsetLeft - x)) best = i; });
      return best;
    }
    const activeIndex = () => pos;
    function syncUi() {
      const vis = visibleSlides();
      pos = Math.max(0, Math.min(vis.length - 1, pos));
      const id = vis[pos] && vis[pos].dataset.mediaId;
      thumbs.forEach((t) => t.setAttribute('aria-current', t.dataset.mediaId === id));
      if (countEl) { countEl.textContent = `${pos + 1} / ${vis.length}`; countEl.hidden = vis.length < 2; }
      if (prevBtn) { prevBtn.disabled = pos === 0; prevBtn.hidden = vis.length < 2; }
      if (nextBtn) { nextBtn.disabled = pos >= vis.length - 1; nextBtn.hidden = vis.length < 2; }
    }
    function goTo(i, smooth = true) {
      const vis = visibleSlides();
      if (!viewport || !vis.length) return;
      pos = Math.max(0, Math.min(vis.length - 1, i));
      syncUi();
      viewport.scrollTo({ left: vis[pos].offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
    }
    function goToMedia(id, smooth = true) {
      const i = visibleSlides().findIndex((sl) => sl.dataset.mediaId === String(id));
      goTo(i < 0 ? 0 : i, smooth);
    }
    if (viewport) {
      let t;
      viewport.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { pos = indexFromScroll(); syncUi(); }, 120); }, { passive: true });
      viewport.addEventListener('scrollend', () => { clearTimeout(t); pos = indexFromScroll(); syncUi(); });
      viewport.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(activeIndex() - 1); }
      });
      // Glisser à la souris sur ordinateur
      let down = null;
      viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        down = { x: e.clientX, i: activeIndex() };
      });
      window.addEventListener('pointerup', (e) => {
        if (!down) return;
        const dx = e.clientX - down.x;
        if (Math.abs(dx) > 40) goTo(down.i + (dx < 0 ? 1 : -1));
        down = null;
      });
      window.addEventListener('resize', () => goTo(pos, false));
    }

    // Les photos dont le texte alternatif contient le nom d'une couleur
    // sont réservées à cette couleur ; les autres s'affichent pour toutes.
    function filterGallery(v) {
      if (colorIndex < 0 || !slides.length) return;
      const color = norm(v.options[colorIndex]);
      const allColors = data.optionValues[colorIndex].map(norm);
      const show = (el) => { const tagged = allColors.find((c) => norm(el.dataset.alt).includes(c)); return !tagged || tagged === color; };
      let any = false;
      slides.forEach((sl) => { sl.hidden = !show(sl); any = any || !sl.hidden; });
      thumbs.forEach((t) => { t.hidden = !show(t); });
      if (!any) { slides.forEach((sl) => { sl.hidden = false; }); thumbs.forEach((t) => { t.hidden = false; }); }
    }

    function update(v, opts = {}) {
      current = v;
      idInput.value = v.id;
      priceEl.innerHTML = (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s>` : '') + formatMoney(v.price);
      const q = Math.max(1, Number(qtyInput.value) || 1);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? `Ajouter · ${formatMoney(v.price * q)}` : 'Épuisé';
      v.options.forEach((val, i) => {
        const lbl = $(`[data-option-value="${i}"]`, root); if (lbl) lbl.textContent = val;
        $$(`[data-option="${i}"]`, root).forEach((b) => b.setAttribute('aria-pressed', b.dataset.value === val));
      });
      filterGallery(v);
      if (!opts.keepMedia) goToMedia(v.featured_media ? v.featured_media.id : null, !opts.instant);
      if (!opts.noUrl) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u);
      }
    }

    root.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-option]');
      if (opt) {
        const idx = Number(opt.dataset.option);
        const want = current.options.slice(); want[idx] = opt.dataset.value;
        const v = variants.find((x) => x.options.every((o, i) => o === want[i]))
          || variants.find((x) => x.options[idx] === opt.dataset.value);
        if (v) update(v);
        return;
      }
      const th = e.target.closest('[data-thumb]');
      if (th) { goToMedia(th.dataset.mediaId); return; }
      if (e.target.closest('[data-gallery-prev]')) { goTo(activeIndex() - 1); return; }
      if (e.target.closest('[data-gallery-next]')) { goTo(activeIndex() + 1); return; }
      const step = e.target.closest('[data-qty-step]');
      if (step) {
        qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + Number(step.dataset.qtyStep));
        update(current, { keepMedia: true, noUrl: true });
      }
    });
    qtyInput.addEventListener('change', () => update(current, { keepMedia: true, noUrl: true }));

    update(current, { noUrl: true, instant: true });
  });

  /* ---------- Date de livraison estimée ---------- */
  $$('[data-eta]').forEach((el) => {
    const min = Number(el.dataset.min), max = Number(el.dataset.max);
    if (!min || !max) return;
    const add = (d) => { const x = new Date(); x.setDate(x.getDate() + d); return x; };
    const f = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    el.textContent = `Commandez aujourd'hui, livraison estimée entre le ${f.format(add(min))} et le ${f.format(add(max))}`;
  });

  // Synchronise le compteur au chargement (retour arrière, autre onglet…)
  if (drawer) getCart().then(renderCart).catch(() => {});
})();
